import React from "react";

import project_1 from "../images/project_1.png"
import project_2 from "../images/project_2.png"
import { useEffect, useRef, useState } from "react";

const useFadeInOnScroll = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return [ref, visible];
};


// Example projects data
const projects = [
  {
    id: 1,
    title: "HardikNotion",
     image: project_1,
    description: `HardikNotion is a full-stack online learning platform for smooth course buying and selling.
Students can purchase and watch courses, while teachers can easily create and manage their content.
Key features include secure authentication, role-based access, safe payments, course management tools, student dashboard, and strong security for protected routes and transactions.`,
    languages: ["Node.js", "Express", "MongoDB", "React"],
    link: "https://hardiknotion.hardikvish.me/",
  },
  {
    id: 2,
    title: "Samvaad",
    image: project_2, 
    description: `Samvaad is a real-time chat application that lets users communicate instantly and securely.
It includes end-to-end protected messaging, online/offline status, media sharing, typing indicators, message delivery receipts, and smooth, reliable performance for seamless conversations.`,
    languages: ["Node.js", "Express", "MongoDB", "React", "Socket.io"],
    link: "https://chat.hardikvish.me/",
  },
];

export default function Project() {
  const [containerRef, isVisible] = useFadeInOnScroll();
  return (
    // <div className=" sm:px-6 md:px-4 py-2 mb-10 md:mb-0">
    <div
  ref={containerRef}
  className={`sm:px-6 md:px-4 py-2 mb-10 md:mb-0
    opacity-0 ${isVisible ? "blur-zoom-in" : ""}
  `}
>
      <h1 className="text-[28px] sm:text-[45px] font-bold mt-[-25px] sm:mt-[-70px]">
        Crafted With Code
      </h1>
      <hr className="h-[4px] sm:h-[5px] bg-cyan-300 border-0 mt-3 w-[80px] sm:w-[100px]" />

      <div className="flex flex-col gap-10 mt-10  sm:px-6 md:px-8 py-2">

      {projects.map((proj, index) => (
  <div
    key={proj.id}
    className="
      flex flex-col md:flex-row 
      rounded-xl overflow-hidden 
      hover:scale-[1.01] transition-transform duration-300 
      h-auto md:h-96 gap-2 
    "
  >
    {/* LEFT SIDE (Image OR Text Depending on Index) */}
    {index % 2 === 0 ? (
      // EVEN index → IMAGE LEFT
      <div className="md:w-1/2 order-1 md:order-1">
        <img
          src={proj.image}
          className="w-full h-60 sm:h-72 md:h-96 object-cover "
          alt="project"
        />
      </div>
    ) : (
      // ODD index → TEXT LEFT
      <div className="md:w-1/2 sm:p-6 flex flex-col justify-center order-2 md:order-1">
        <h2 className="text-xl sm:text-2xl font-bold text-white">{proj.title}</h2>
        <p className="text-gray-300 mt-3 text-sm sm:text-base leading-relaxed">
          {proj.description}
        </p>

        <div className="flex flex-wrap gap-2 mt-4">
          {proj.languages.map((lang, i) => (
            <span
              key={i}
              className="px-2 py-1 text-xs sm:text-sm bg-cyan-600 text-white rounded-full"
            >
              {lang}
            </span>
          ))}
        </div>

        <a
          href={proj.link}
          target="_blank"
          rel="noreferrer"
          className="inline-block mt-6 px-5 py-2 bg-cyan-500 text-white font-semibold rounded-lg shadow hover:bg-cyan-600 transition text-sm sm:text-base"
        >
          View Project
        </a>
      </div>
    )}

    {/* RIGHT SIDE (Opposite side) */}
    {index % 2 === 0 ? (
      // EVEN index → TEXT RIGHT
      <div className="md:w-1/2  sm:p-6 flex flex-col justify-center order-2 md:order-2">
        <h2 className="text-xl sm:text-2xl font-bold text-white">{proj.title}</h2>
        <p className="text-gray-300 mt-3 text-sm sm:text-base leading-relaxed">
          {proj.description}
        </p>

        <div className="flex flex-wrap gap-2 mt-4">
          {proj.languages.map((lang, i) => (
            <span
              key={i}
              className="px-3 py-1 text-xs sm:text-sm bg-cyan-600 text-white rounded-full"
            >
              {lang}
            </span>
          ))}
        </div>

        <a
          href={proj.link}
          target="_blank"
          rel="noreferrer"
          className="inline-block mt-6 px-5 py-2 bg-cyan-500 text-white font-semibold rounded-lg shadow hover:bg-cyan-600 transition text-sm sm:text-base"
        >
          View Project
        </a>
      </div>
    ) : (
      // ODD index → IMAGE RIGHT
      <div className="md:w-1/2 order-1 md:order-2">
        <img
          src={proj.image}
          className="w-full h-60 sm:h-72 md:h-96 object-cover"
          alt="project"
        />
      </div>
    )}

  </div>
))}
















      </div>

      {/* Loading Animation Box */}
      <div
        className="
          border border-gray-600 
          h-64 sm:h-80 md:h-96 
          px-4 sm:px-6 py-6 
          mx-auto md:ml-8 
          rounded-lg flex items-center justify-center
        "
      >
        <div className="relative w-36 sm:w-44 h-36 sm:h-44 flex items-center justify-center">
          {/* Static Dots */}
          {[...Array(24)].map((_, i) => (
            <span
              key={i}
              className="absolute w-2 sm:w-3 h-2 sm:h-3 bg-blue-500 rounded-full opacity-40"
              style={{
                transform: `rotate(${i * 15}deg) translate(60px)`,
              }}
            ></span>
          ))}

          {/* Rotating Glow */}
          <div className="absolute inset-0 animate-rotate-glow">
            {[...Array(24)].map((_, i) => (
              <span
                key={i}
                className="absolute w-2 sm:w-3 h-2 sm:h-3 bg-blue-400 rounded-full shadow-[0_0_12px_#3b82f6]"
                style={{
                  transform: `rotate(${i * 15}deg) translate(60px)`,
                  opacity: i === 0 ? 1 : 0,
                }}
              ></span>
            ))}
          </div>

          {/* Loading Text */}
          <p className="text-blue-400 text-lg sm:text-xl font-semibold tracking-widest">
            LOADING
          </p>
        </div>
      </div>
    </div>
  );
}
